import ENV from 'dashboard/config/environment';
import { warn } from '@ember/debug';

/**
 * Handle missing translations.
 * In production, we simply surface the English key.
 *
 * @see https://ember-intl.github.io/ember-intl/versions/v6.1.0/docs/guide/missing-translations#at-runtime
 *
 * @param {string} key
 * @param {array} locales
 * @param {object} options
 */
export default function missingMessage(key, locales /*, options */) {
  const localeNames = locales.join(', ');

  if (ENV.environment === 'production') {
    // show the user the English key in production
    return key;
  }

  warn(
    `[ember-intl] translation: "${key}" on locale: "${localeNames}" was not found.`,
    false,
    {
      id: 'ember-intl-missing-translation',
    }
  );

  return `Missing translation: "${key}"`;
}
